import { render, staticRenderFns } from "./tenant-roster-index.vue?vue&type=template&id=c53371b6"
import script from "./tenant-roster-index.vue?vue&type=script&lang=js"
export * from "./tenant-roster-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports